import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button, { ButtonStyle } from '../../../common/components/Button/Button';
import SVGCaretLeft from '../../../common/assets/svg/icons/SVGCaretLeft';
import { Routes } from '../../../config/routes';
import FlowMode from '../../../providers/validation/FlowMode';
import { ValidationContext } from '../../../providers/ValidationContext';

interface BackToChooserProps {
  currentRoute: Routes;
}

export default function BackToChooser({ currentRoute }: BackToChooserProps): JSX.Element {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { flowMode, setFlowMode, resetPendingStepsForRoute } = useContext(ValidationContext);
  const [buttonVisible, setButtonVisible] = useState(false);

  const handleBackButtonClick = () => {
    resetPendingStepsForRoute(currentRoute);
    setFlowMode(FlowMode.userSelect);
    navigate(-1);
  };

  useEffect(() => {
    setButtonVisible(flowMode === FlowMode.full);
  }, [flowMode]);

  return (
    <>
      {buttonVisible && (
        <div className="flex-basis-0 items-left w-full pb-4">
          <Button
            style={ButtonStyle.BACK}
            onClick={handleBackButtonClick}
            disabled={false}
            extraClasses="back-button"
            dataTestid="BACK_BUTTON"
          >
            <div className="flex text-textTertiary uppercase text-xs items-center">
              <SVGCaretLeft />
              <span className="ml-2">{t('common.explainer.backButtonLabel')}</span>
            </div>
          </Button>
        </div>
      )}
    </>
  );
}

BackToChooser.defaultProps = {};
